export const SOCIAL_LINKING_PLATFORMS = ['instagram', 'tiktok', 'youtube', 'linkedin', 'facebook'] as const;

export type SocialLinkingPlatform = (typeof SOCIAL_LINKING_PLATFORMS)[number];

export function isSocialLinkingPlatform(
  value: unknown,
): value is SocialLinkingPlatform {
  return typeof value === 'string'
    && (SOCIAL_LINKING_PLATFORMS as readonly string[]).includes(value);
}

/** Platforms every viewer may link; Facebook is gated server-side (`mySocialLinkingPlatforms`). */
export const DEFAULT_SOCIAL_LINKING_PLATFORMS: SocialLinkingPlatform[] = SOCIAL_LINKING_PLATFORMS
  .filter((platform) => platform !== 'facebook');

/** Whether the platform is a known linking platform; per-viewer gating is `useSocialLinkingPlatforms`. */
export function isSocialLinkingPlatformVisible(
  platform: SocialLinkingPlatform,
): boolean {
  return SOCIAL_LINKING_PLATFORMS.includes(platform);
}
